export const goBack = fallbackUrl => {
  if (fallbackUrl && !document.referrer) {
    window.location = fallbackUrl
  } else {
    window.history.back()
  }
}
